// THIS FILE IS USED TO GENERATE CHUNKS PER PAGE
// SO THAT SPA'S CAN LOAD THE NECESSARY CHUNKS PER PAGE
/* eslint-disable no-nested-ternary */
import { generateAsyncRoute } from '@thd-olt-component-react/router';

const ssr = typeof window === 'undefined';

export const getServerPages = async () => {
  const Components = {};
  if (ssr) {
    Components.Assistant = (await import('./pages/Assistant')).Assistant;
  }
  return Components;
};

export const getRoutes = (currentRouteName, currentRouteComponent, serverPages) => ({
  assistant: {
    name: 'Assistant',
    componentName: 'Assistant',
    chunk: () => import('./pages/Assistant'),
    get component() {
      return ssr
        ? serverPages.Assistant
        : currentRouteName === 'Assistant'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.Assistant })));
    },
    path: '/:context?/magic-apron/assistant',
    channel: null
  }
});
